import type { FormFields } from '@/entities/purchase-form';

type BuildLines = {
    numbers: number[];
    firstIsRequired: boolean;
};

export const buildLines = ({
    numbers,
    firstIsRequired,
}: BuildLines): NonNullable<FormFields['personalization']['frontLines']> => {
    return numbers.map((max, index) => ({
        max,
        text: '',
        order: index + 1,
        required: firstIsRequired ? index === 0 : false,
    }));
};
